const spacer = {
  xs: '0.25rem',
  s: '0.5rem',
  m: '1rem',
  l: '2rem',
  xl: '4rem'
};

const height = {
  xs: '1.5rem',
  s: '2rem',
  m: '2.5rem',
  l: '3.75rem',
  header: '3rem'
};

const padding = {
  verticalXS: '0.25rem',
  verticalS: '0.375rem',
  verticalM: '0.5rem',
  verticalL: '0.75rem',
  verticalXL: '1rem',
  verticalPage: '1.5rem',
  horizontalXS: '0.375rem',
  horizontalS: '0.5625rem',
  horizontalM: '0.75rem',
  horizontalL: '1.125rem',
  horizontalXL: '1.5rem',
  horizontalXSpill: '0.75rem',
  horizontalSpill: '1rem',
  horizontalMpill: '1.25rem',
  horizontalLpill: '1.875rem',
  horizontalNav: '1.25rem',
  horizontalPage: '1.5rem'
};

const marginBottom = {
  xs: '1rem',
  s: '1rem',
  m: '1.25rem',
  l: '1.5rem',
  xl: '2rem',
  xxl: '2.25rem'
};

const marginHeading = {
  h1: '1rem',
  h2: '0.75rem',
  h3: '0.75rem',
  h4: '0.5rem',
  h5: '0.5rem',
  h6: '0.5rem'
};

const spacerUnits = {
  spacer,
  height,
  padding,
  marginBottom,
  marginHeading
};

export default spacerUnits;



// WEBPACK FOOTER //
// ./src/global/spacer.js